// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import PartnerLogin from './PartnerLogin.vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ja'
import 'element-ui/lib/theme-chalk/index.css'
import Server from '@/components/ServerApi.js'

Vue.use(ElementUI, { locale })
Vue.config.productionTip = false

new Vue({
    el: '#partner-login',
    template: '<PartnerLogin/>',
    components: { PartnerLogin }
})

